// Styles
import { makeStyles, tokens } from "@fluentui/react-components";
// Utilities
import { flexParent, flexParentCenterAll } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
// Style constants
const INPUT_HEIGHT = "32px";
const DIALOG_MAX_WIDTH = "560px";
const PICKER_MAX_WIDTH = "512px";
/**
 * Hook to get styles for the SelectPlanModal
 */ export const useSelectPlanModalStyles = makeStyles({
    root: {
        borderRadius: tokens.borderRadiusXLarge,
        backgroundColor: tokens.colorNeutralBackground1,
        maxWidth: DIALOG_MAX_WIDTH,
        width: "70%",
        ...flexParent("column")
    },
    planPicker: {
        maxWidth: PICKER_MAX_WIDTH,
        width: "100%",
        maxHeight: "225px"
    },
    dropdownButton: {
        color: tokens.colorNeutralForeground2,
        backgroundColor: tokens.colorNeutralBackground3,
        fontSize: tokens.fontSizeBase300,
        padding: "6px 8px",
        border: "none",
        borderRadius: tokens.borderRadiusXLarge,
        width: "100%",
        height: INPUT_HEIGHT,
        cursor: "pointer",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },
    planSelectionDropdownIcon: {
        lineHeight: "14px",
        color: tokens.colorNeutralForeground3
    },
    placeholderContent: {
        color: tokens.colorNeutralForeground3
    },
    planContent: {
        color: tokens.colorNeutralForeground1,
        height: "20px",
        paddingRight: "20px"
    },
    dropdownIcon: {
        bottom: INPUT_HEIGHT,
        minWidth: INPUT_HEIGHT,
        backgroundColor: "transparent",
        border: "none",
        padding: "0px",
        color: tokens.colorNeutralForeground3
    },
    dropdownButtonContainer: {
        marginBottom: "40px",
        backgroundColor: tokens.colorNeutralBackground3,
        borderRadius: tokens.borderRadiusXLarge
    },
    errorContent: {
        ...flexParent("column"),
        ...flexParentCenterAll
    },
    primaryButton: {
        borderRadius: tokens.borderRadiusXLarge
    }
});
